export const ensureTrailingSlash = (url) => {
  if (!url) {
    return url;
  }

  return url.endsWith('/') ? url : `${url}/`;
};
